import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.ts";
import {EventStore} from "../server/EventStore.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import * as calendar_modal from "./calendar_modal.ts";
import * as libLocation from "../lib/location.ts";
import * as i18n from "../i18n.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import * as Storage from "../lib/Storage.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import Icons from "../svg/Icons.ts"
import deviceId from "../lib/deviceId.ts";
import { OS } from "../lib/os.ts";
import FizConfig from "../FizConfig.ts";
import "./ical.ts";
import MultiplexApi from "../server/MultiplexApi.ts";
import {pickFileFromDevice} from "../lib/FileUtils.ts";
import * as progressbar from "../util/progressbar.ts";

//timetable are used in calendar page so we need all this
import "../timetable/page_timetable.ts";

import  {Calendar, ResourceApi, selectionInfo, ViewImpl} from "../lib/fullcalendar/all.ts";
import { eventDrop, eventModified } from "./fullcalendar_dragdrop.ts";
import { calendarclean, checkEventLimit, checkEventLimitOntry } from "./calendarclean.ts";
import { MemberOrder, memberToggleFilter } from "../util/MemberOrder.ts";
import { displayAiInboxFeatureIfNeeded } from "../features/aiinbox.ts";
import "./manageimport.ts";
import { isFeatureEnabled } from "../lib/launchdarkly/launchdarkly.ts";
import { aiImportCredits, importDroppedFile, resumeAiImport } from "./aiimport.ts";
import { importCalendarFile } from "./icsimport.ts";
import * as segment from "../tracking-segment.ts";

var navigationContext = {
  page:0,
  pageCount:1
}
actionMenu.register({
  calendarsettings(){
    var menu :actionMenu.ActionMenuButton[] = [
      {svg:Icons.ic_settings,onclick:'calendarsettings',i18nkey:'headings.settings'},
      {svg:Icons.calendar.ic_calendar_cleanup,onclick:'calendarclean',i18nkey:'actions.clean'},
      {svg:Icons.ic_email,i18nkey:'actions.inbox',onclick:"aiinboxmodal",permission:"aiImport",beta:true},
      {svg:Icons.clock.ic_history,onclick:'manageimport',i18nkey:'manageimport.menu'},
      {svg:Icons.ic_print,onclick:'print',i18nkey:'actions.print'}
    ];
    
    return {menu}
  },
  calendarview(){
    const isPremium = FwDatas.getState().premium.audio;
    return {
      menu:[
        {svg:Icons.calendar.ic_calendar_view_day,onclick:'calendarview|timeGridDay',i18nkey:'eventCalendarNav.day'},
        {svg:isPremium?Icons.calendar.ic_calendar_view_member:Icons.premium.ic_premium_crown,onclick:'calendarview|resourceTimeGridDay',i18nkey:'eventCalendarNav.schedule'},
        {svg:Icons.calendar.ic_calendar_view_week,onclick:'calendarview|timeGridWeek',i18nkey:'eventCalendarNav.week'},
        {svg:Icons.calendar.ic_calendar_view_month,onclick:'calendarview|dayGridMonth',i18nkey:'eventCalendarNav.month'},
        {svg:Icons.calendar.ic_calendar_view_year,onclick:'calendarview|listYear',i18nkey:'eventCalendarNav.planning'},
      ]}
  }
})
  var
  // Constants
  selectedCalendarIds,
  currentFullCalendar;



INR.onPage(INR.URL.EVENTS_OUTLOOKRETURN,function(){
  var
    error = libLocation.getURLParam('error'),
    code = libLocation.getURLParam('code');
  if(error){
    modal.oops('fw2.defaultError')
    ApiServer.webjslog('outlookreturn error '+error)
  }else if(code){
    ApiServer.outlooklogin(code,function(credential){
      import("../modal/caloutlook_edit.mustache").then(function(TPL){
        modal.openDomModal(TPL,credential);
      });
    },function(){
      libLocation.goTo('events.php');
    })
  }else{
    ApiServer.webjslog('outlookreturn without error nor code')
  }
  libLocation.goTo('events.php');
})
Html.registerDom({

  calendartoday() {
    currentFullCalendar.today();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  },
  calendarnext() {
    currentFullCalendar.next();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  },
  calendarprev() {
    currentFullCalendar.prev();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  },
  paginationnext() {
    navigationContext.page = Math.min(navigationContext.page+1,navigationContext.pageCount-1);
    currentFullCalendar.refetchResources()
    currentFullCalendar.render();
  },
  paginationprev() {
    navigationContext.page = Math.max(navigationContext.page-1,0);
    currentFullCalendar.refetchResources()
    currentFullCalendar.render();
  },
  calendarview(value){
    Storage.localSet('settings.calendarView',value);
    currentFullCalendar.changeView(value)
    updateViewSelector()
  },
  calendarsettings() {
    import("./modal_settings.mustache").then(function(TPL){
      modal.openDomModal(TPL,{
        settings:FwDatas.getSettingsPerFamily(),
        weekdays:DateUtils.getWeekDays()
      });
    });
  },
  calendarclean,

  async importcalendar(){
    var datas = await MultiplexApi.settingsaiinboxcheck(undefined);
    var hasAiImport = FwDatas.getPermission('aiImport') === 'OK';
    var syncLocked = FwDatas.getPermission('googleconnect') === 'takepremium';
    var emailAddress = datas.current ? datas.current + '@' + datas.domain : '';
    var TPL = await import('./importcalendar.mustache');
    var domModal = modal.openDomModal(TPL, {hasAiImport, syncLocked, emailAddress, aiImportCredits:aiImportCredits()});
    var dropZone = domModal.querySelector('.importcalendar-dropzone') as HTMLElement;
    if(dropZone){
      dropZone.addEventListener('dragover', (e)=>{e.preventDefault(); dropZone.style.borderColor='var(--fwPrimary)';});
      dropZone.addEventListener('dragleave', ()=>{dropZone.style.borderColor='';});
      dropZone.addEventListener('drop', (e)=>{
        e.preventDefault();
        dropZone.style.borderColor='';
        if(e.dataTransfer?.files.length){
          var file = e.dataTransfer.files[0];
          if(isFeatureEnabled('fwall-32-ai-event-import-quick-add')){
            modal.closeDomModal(domModal);
            importDroppedFile(file);
          }else{
            importCalendarFile(file);
          }
        }
      });
    }
  },
  async importcalendarfile(){
    if(isFeatureEnabled('fwall-32-ai-event-import-quick-add')){
      Html.trigger(this,'aiimportfile');
      return;
    }
    var files = await pickFileFromDevice("text/calendar");
    if(files.length === 0) return;
    await importCalendarFile(files[0]);
  }

})

async function updateViewSelector(){
  var lastView = Storage.localGet('settings.calendarView')||'dayGridMonth';
  var selectedMenu = (await actionMenu.getData(null,'calendarview')).menu.find(menuItem=>menuItem.onclick==='calendarview|'+lastView);
  document.querySelector('[data-key="calendarview"]').innerHTML = (`<icon style="font-size:24px">${selectedMenu.svg}</icon><span>${i18n.get(selectedMenu.i18nkey)}</span><icon style="font-size:24px">${Icons.ic_chevron_down}</icon>`)

  var
    memberorderData = await MemberOrder.need(),
    selected = memberorderData.filter(member=>member.activated).map(profile=>`<span><img src="${profile.member.thumb()}"/></span>`),
    selectedCount = memberorderData.filter(member=>member.activated).length,
    button = document.querySelector('*[data-fw-onclick="memberordersettings"]');

    button.innerHTML = (`${selected.join('')}<span>${selectedCount}</span>`)


  var navigationContainer = document.querySelector<HTMLElement>('.paginationnav')
  if(navigationContext.pageCount===1 || lastView!=='resourceTimeGridDay'){
    document.querySelector<HTMLElement>('.paginationnav').style.display = 'none'
  }else{
    navigationContainer.style.display = 'block';
    navigationContainer.querySelector<HTMLElement>('.paginationtext').innerText = ((navigationContext.page+1)+'/'+navigationContext.pageCount);
    navigationContainer.querySelector<HTMLElement>('[data-fw-onclick="paginationprev"]').classList.toggle('disabled',navigationContext.page===0)
    navigationContainer.querySelector<HTMLElement>('[data-fw-onclick="paginationnext"]').classList.toggle('disabled',navigationContext.page===navigationContext.pageCount-1)

  }
}

INR.onPage(INR.URL.EVENTS,async function(){
  segment.track("Calendar Viewed");

  //TODO remove this invalidate, but test a lot before
  EventStore.invalidate();
  selectedCalendarIds = null;

  if(libLocation.getURLParam('googlereturn') && !libLocation.getURLParam('error')){
    ApiServer.googlelogin2(libLocation.getURLParam('code'),function(credential){
      import("../modal/calgoogle_edit.mustache").then(function(TPL){
        modal.openDomModal(TPL,credential);
      });
    },function(){
      libLocation.goTo('events.php');
    })
  }
  if(FwDatas.getState().timeZone!== OS.getTimeZone()){
    var showToast = localStorage.getItem('timewarpshow')!=='false'
    if(showToast){
      modal.toast({
        emoji:'🕰️',
        text:'timezone.changetoasttitle',
        button:[{title:"actions.learnmore",onclick(){
          modal.ask({
            title:'timezone.changealerttitle',
            message:'timezone.changealertdescription',
            lottie:"images/lottie/anim_clock.json",
            checkbox:[{
              title:"actions.dontshowagain",
              onclick(checked:boolean){
                localStorage.setItem('timewarpshow',(!checked)+"")
              }
            }],
            button:[{title:'actions.gotit'}]
          })
        }}]
      })
    }

    ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.VERSION||"",OS.getTimeZone()).then((accountState=>{
      FwDatas.setState(accountState);
    }))
  }
  
  if(isFeatureEnabled('fwall-32-ai-event-import-quick-add')){
    //Quick Add and its discoveries replace the email import announcement
    resumeAiImport().catch(console.log)
  }else{
    displayAiInboxFeatureIfNeeded()
  }
  
  var lastView = Storage.localGet('settings.calendarView')||'dayGridMonth';
  if(["timeGridDay","timeGridWeek","dayGridMonth","listYear","resourceTimeGridDay"].indexOf(lastView)===-1){
    lastView = 'dayGridMonth'
  }

  var
    userSettings = FwDatas.getSettingsPerFamily()||{},
    scheduleResources = async function(){
      var
        selectedRessource = (await MemberOrder.refresh()).filter(a=>a.activated===true).map(enrichedMember=>{

          return {
            id:enrichedMember.member.accountId,
            title:enrichedMember.member.firstName,
            sortingIndex :enrichedMember.sortingIndex
          }
        }),
        paginationSize = Math.ceil((document.getElementById("fullcalendar").clientWidth - 50)/150);

      navigationContext.pageCount = Math.ceil(selectedRessource.length/paginationSize)
      if(navigationContext.page>=navigationContext.pageCount){
        navigationContext.page = navigationContext.pageCount-1;
      }
      updateViewSelector()
      return selectedRessource.slice(navigationContext.page*paginationSize,navigationContext.page*paginationSize+paginationSize)
    }

  currentFullCalendar = new Calendar(document.getElementById("fullcalendar"),{
    nowIndicator:true,
    resourceOrder :'sortingIndex',
    resources:scheduleResources,
    resourceLabelContent(data : {date:Date,resource:ResourceApi ,view :ViewImpl}){
      var user = FwDatas.getProfile(data.resource.id);
      return {html:`<img class="fw-avatar" style="margin-bottom:8px" src="${user.medias[0].url(120,120,'c')}"><br/>${user.firstName}`}
    },
    initialView:lastView,
    locale: i18n.getSelectedLanguage(),
    weekNumbers:userSettings.calendarWeekNb,
    firstDay:userSettings.calendarFirstDayOfWeek%7,
    scrollTime:'08:00:00',
    height:"parent",
    editable: true,
    //buttonText:i18n.get('eventCalendarNav'),
    headerToolbar: false,
    views: {
      dayGridMonth: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', omitZeroMinute: true, meridiem: 'short' }
      },
      week: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' }
      },
      day: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' },
        titleFormat: { weekday: 'short',  year: 'numeric', month: 'long', day: 'numeric' }
      }
    },
    listDayFormat(info){
      var date = new Date(info.date.marker.toISOString().substring(0,10)+'T00:00:00')
      return DateUtils.format(date,'dddd LL')
    },
    eventDisplay:'block',
    datesSet(info){
      document.getElementById('calendartitledisplay').innerText = (info.view.title);
      if(info.view.type==='listYear'){
        function autoscroll(){
          let
            allDates = document.querySelectorAll('[data-date]'),
            smallerBefore = null;
            
          for(let i=0;i<allDates.length;i++){
            let elem = allDates[i];
            if(new Date(elem.getAttribute('data-date'))<new Date()){
              smallerBefore = elem;
            }else{
              break;
            }
          }
          if(smallerBefore){
            smallerBefore.scrollIntoView();
          }
        }
        setTimeout(autoscroll,400)
      }
    },
    events(range, successCallback,failureCallback){

      //refresh (read from local storage) and not need, a need could return a selection saved less than 60s ago
      MemberOrder.refresh().then(data=>{
        if(data.every(info=>info.activated)){
          return []
        }
        return data.filter(info=>info.activated).map(info=>info.member.accountId)
      }).then(selectedMembers=>{
        EventStore.loadEventsBySync(selectedCalendarIds,selectedMembers,range).then(evts=>{
          var allmembersids = MemberOrder.datas.map(info=>info.member.accountId)
          successCallback(evts.map(function(ev){
            var color = ev.calendar.color;
            if(ev.calendar.useEventColor && ev.color){
              color = ev.color
            }
            /*
            if(ev.computedComplete){
              color = "#ccc"
            }
            */
            //an event without any attendee would have no column in the resource view, display it for everybody
            var resourceIds = ev.toAll||!ev.attendeeIds||ev.attendeeIds.length===0?allmembersids:ev.attendeeIds;

            return {
              start:ev.start,
              end:ev.allDay?new Date(new Date(ev.end).getTime()+1000) :ev.end,
              title:ev.private?'🔒 '+ev.title:ev.title,
              color:color,
              id:ev.metaId,
              allDay:ev.allDay,
              resourceIds,
              editable:ev.draggable && !ev.isSpecialDaysEvent,
              durationEditable :!ev.isTaskEvent && !ev.isMealplannerEvent && !ev.isSpecialDaysEvent,
              resourceEditable:ev.draggable && !ev.isMealplannerEvent && !ev.isSpecialDaysEvent
            }
          }))
        },failureCallback);
      })
    },
    selectable:true,
    select(selectionInfo : selectionInfo ){
      var
        start = new Date(selectionInfo.start),
        end = new Date(selectionInfo.end);
      if(selectionInfo.allDay){
        end.setDate(end.getDate()-1);
        start.setHours(9);
        end.setHours(10);
      }
      calendar_modal.createEvent(start,end,selectionInfo.allDay, undefined,selectionInfo.resource);

    },
    eventClick(obj){
      var id = obj.event.id;
      Html.trigger(obj.el,"evtclick",[id])
    },
    eventResize: eventModified,
    eventDrop
  });



  INR.subscribe("eventCreated eventUpdated eventDeleted contactUpdated eventCommented",function(iEvent){
    EventStore.invalidate((metaId :string)=>{
      return metaId.startsWith('calendar/')||metaId.startsWith('calendarSpecialDays/')}
    );
    if(iEvent && iEvent.attendeeIds){
      memberToggleFilter(true,...iEvent.attendeeIds);
    }
    currentFullCalendar.refetchEvents();
  });
  INR.subscribe("dishChange",function(){
    EventStore.invalidate((metaId :string)=>{
      return metaId.startsWith('calendarMealPlanner/')}
    )
    currentFullCalendar.refetchEvents();
  });

  INR.subscribe("taskNeedRefresh",function(){
    EventStore.invalidate((metaId :string)=>{
      return metaId.startsWith('calendarTask/')}
    );
    currentFullCalendar.refetchEvents();
  });
  INR.subscribe("calendarSelection",function(selected){
    selectedCalendarIds = selected;
    currentFullCalendar.refetchEvents();
  });
  INR.subscribe("calendarModification",function(selected){
    selectedCalendarIds = selected;
    //maybe no need to do that here
    EventStore.invalidate();
    currentFullCalendar.refetchEvents();
  });

  INR.subscribe('timetableUpdated',function(fresh){
    modal.closeDomModal();
    EventStore.invalidate(metaId=>metaId.startsWith('calendarTimetable/'));
    currentFullCalendar.refetchEvents();
  })
  INR.subscribe("calendarNeedRender resized",function(){
    currentFullCalendar.render();
  });
  INR.subscribe("DatePicker",function(date : Date){

    currentFullCalendar.gotoDate(date);
  });
  INR.subscribe("familyMemberChange",function(date : Date){
    currentFullCalendar.refetchResources();
    currentFullCalendar.refetchEvents();
    currentFullCalendar.render();
  });

  function render(){
    currentFullCalendar.render();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  }
  //FIXME hack because calendar is not displayed and cannot understand why
  setTimeout(render,1);

  ApiServer['custom.calendarsettingssetperfamily'] = function(form,success,error){
    let
      calendarWeekNb = form.calendarWeekNb.value,
      calendarFirstDayOfWeek = form.calendarFirstDayOfWeek.value,
      defaultReminderType = 'NONE',
      defaultReminderUnit = undefined,
      defaultReminderValue = undefined,
      defaultReminderDatas = form.defaultReminder.value.split('-');

    if(defaultReminderDatas.length>1){
      defaultReminderType = 'SNOOZE';
      defaultReminderUnit = defaultReminderDatas[0];
      defaultReminderValue = defaultReminderDatas[1];
    }

    ApiServer.settingssetperfamily(new ApiServer.types.ISettingsPerFamily({
      defaultReminderType,
      defaultReminderUnit,
      defaultReminderValue,
      calendarWeekNb,
      calendarFirstDayOfWeek
    }),function(settingsPerFamily){
      FwDatas.setSettingsPerFamily(settingsPerFamily);
      modal.closeDomModal();
      libLocation.refresh();
    },success,error)
  }


  checkEventLimit()



});